import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/dashboard/fields/$fieldId/insights/hydroflow',
)({
  component: () => <Outlet />,
})
